import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { OfferItemWrapper } from '../OffersList/style';

export const OffersMobileContainer = styled.div`
  display: grid;
  grid-template-columns: 80px 60px auto 1fr;
  column-gap: 20px;
  align-content: center;

  width: 100%;
  height: 35px;
  margin: 10px 0;
  padding: 0 15px;

  @media (max-width: 420px) {
    column-gap: 10px;
  }

  @media (max-width: 360px) {
    grid-template-columns: 80px 60px 1fr;
  }
`;

export const SignupOfferWrapper = styled.div`
  grid-column: 2;
`;

export const SpecialOfferWrapper = styled.div`
  grid-column: 3;

  @media (max-width: 360px) {
    display: none;
  }
`;

export const OfferAmount = styled.p`
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
  color: var(--ogm-grid-offer-color);
`;

const labelStyles = `
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 14px;
  color: var(--oc-text-subtext);
  white-space: nowrap;
`;

export const OfferLabel = styled.p`
  ${labelStyles}
`;

export const LabelPart = styled.span`
  ${labelStyles}

  @media (max-width: 380px) {
    display: none;
  }
`;

export const SeeOffersBtn = styled.button`
  grid-column: -2;
  justify-self: end;
  padding: 5px 8px 6px;
  background: var(--ogm-grid-offer-bg-color);
  font-family: var(--ogm-font-family-2);
  color: var(--oc-primary-white);
  border-radius: 5px;
  white-space: nowrap;
  max-width: 87px;
`;

export const OfferDesktopContainer = styled.div`
  --oc-offer-cell-height-top: 23;
  --oc-offer-cell-height-bottom: 21;
  --oc-offer-cell-margin: 5;

  width: var(--ogm-grid-cell-width-desktop);
  min-width: var(--ogm-grid-cell-width-desktop);
  margin: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OfferDesktopCell = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--ogm-grid-offer-bg-color);

  &:hover {
    cursor: pointer;
  }
`;

export const OfferDesktopCellText = styled.span`
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: var(--ogm-grid-offer-color);
  user-selection: none;
`;

export const OfferDesktopCellTop = styled(OfferDesktopCell)`
  height: calc(var(--oc-offer-cell-height-top) * 1px);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

export const OfferDesktopCellBottom = styled(OfferDesktopCell)`
  height: calc(var(--oc-offer-cell-height-bottom) * 1px);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  > svg {
    color: var(--ogm-grid-offer-color);
    position: relative;
    top: -1px;
    margin-right: 2px;
  }

  > span {
    position: relative;
    top: -1px;
  }
`;

export const roundedCell = css`
  border-radius: 5px;
`;

export const presentIcon = css`
  position: relative;
  top: -1px;
  margin-right: 2px;
`;

export const offerItemWidth = 290;

export const TooltipWrapper = styled.div<{
  width: number;
}>`
  width: ${props => `${props.width}px`};
  display: flex;

  & ${OfferItemWrapper} {
    width: ${offerItemWidth + 'px'};
    margin-top: 0;
    margin-right: 1px;
  }
`;

export const tooltipScrollContainer = css`
  max-width: 100vw;
  flex-wrap: nowrap;
  background-color: transparent;
`;

export const OffersBarContainer = styled.div<{
  x: string;
  y: string;
}>`
  position: fixed;
  top: ${props => props.y};
  left: ${props => props.x};
  /* Takeover ads are z-index: 101, these need to overlap */
  z-index: var(--cxy-z-index-above-ad);
`;
const OffersBarScrollButton = styled.button`
  position: absolute;
  top: calc(50% - 30px);
  display: flex;
  align-items: center;
  width: 60px;
  height: 60px;
  z-index: var(--cxy-z-index-modal-overlay-bg);
`;

export const OffersBarScrollButtonLeft = styled(OffersBarScrollButton)`
  left: 0;
  padding-left: 25px;
`;

export const OffersBarScrollButtonRight = styled(OffersBarScrollButton)`
  right: 0;
  padding-right: 25px;
`;

export const offersBarScrollButtonLeftHide = css`
  transform: translateX(-250px);
`;

export const offersBarScrollButtonRightHide = css`
  transform: translateX(250px);
`;

const OffersBarScrollButtonIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 33px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
  z-index: var(--cxy-z-index-internal-base);

  &:after {
    content: '';
    left: -2px;
    width: 10px;
    height: 10px;
  }
`;

export const OffersBarScrollButtonIconLeft = styled(OffersBarScrollButtonIcon)`
  &:after {
    border-top: 2px solid var(--ogm-text-body);
    border-left: 2px solid var(--ogm-text-body);
    transform: rotate(-45deg);
  }
`;

export const OffersBarScrollButtonIconRight = styled(OffersBarScrollButtonIcon)`
  &:after {
    border-top: 2px solid var(--ogm-text-body);
    border-right: 2px solid var(--ogm-text-body);
    transform: rotate(45deg) translate(-2px, 1px);
  }
`;
